export default "/institutions/robinhood.svg";